import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
// import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";
import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";

// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
import swal from "sweetalert";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import { useEffect, useState } from "react";
import CallIcon from "@mui/icons-material/Call";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import ToggleButton from "@mui/material/ToggleButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";

// For Tab
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// End

import bungalow from "../../../assets/Images/bungalow.png";
import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
// import { fetchToken, onMessageListener } from "../../firebase.js";

import Zoom from "react-medium-image-zoom";
import QRCode from "react-qr-code";
// import QRReader from 'react-qr-reader';
import { QRReader } from "react-qr-scanner";
// For Modal
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import { HTML5QrcodeScanner, Html5Qrcode, Html5QrcodeScanner } from "html5-qrcode";

import CsvDownloader from "react-csv-downloader";
import ExcelToTable from "../../ExcelToTable"

function TabPanel(props) {
  const { children, value, index, ...other } = props;


  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function ResidentManagement2() {
  const [csvdataarray, setforcsv] = React.useState([]);

  // const [scanResult, setScanResult] = useState(null);

  const [open2, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [importError, setImportError] = useState(null);

  const handleClose2 = () => {
    setOpen(false);
  };

  const handleScan = data => {
    if (data) {
      console.log('Result: ', data);
    }
  }

  const handleError = err => {
    console.error(err);
  }

  const [selected, setSelected] = React.useState(false);

  const navigate = useNavigate();

  // For memu
  const [anchorEl10, setAnchorEl10] = React.useState(null);
  const open10 = Boolean(anchorEl10);

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(5);
  const [totalItems, setTotalItems] = React.useState(0);

  const handleClick10 = (event) => {
    setAnchorEl10(event.currentTarget);
  };
  const handleClose10 = () => {
    setAnchorEl10(null);
  };
  // End

  // For Tab
  const [value, setValue] = React.useState(0);

  const [defaultProfilePic, setDefaultProfilePic] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // End

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isTenent, setIsTenent] = React.useState(false);
  const [Upload, setUpload] = React.useState(false);

  const open = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   alert("Hi")
  //   setAnchorEl(event.currentTarget);
  // };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // End

  // async function handleChangeTabs(residentType) {
  //   if (residentType == "Tenent") setIsTenent(true);
  //   else setIsTenent(false);

  //   residentlisting();
  // }

  const [length, setlength] = React.useState();
  const [residentlist, setresidentlist] = React.useState([]);
  const [tenentlist, setTenentlist] = React.useState([]);
  const [showLoader, setShowLoader] = React.useState(false);
  const [q, setQ] = React.useState("");
  const [status, setStatus] = React.useState("Owner");

  async function tenentListing() {
    await makeGetRequest("tenent/getall")
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data.rows);
          // setlength(response.data.data.data.length)
          const data = response.data.data.rows;
          setTenentlist(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const [sortBy, setSortBy] = React.useState("");

  async function handleChangeSortBy(event, residentType) {
    if (sortBy == "ASC") {
      setSortBy("DESC");
    } else {
      setSortBy("ASC");
    }
    residentlisting(residentType);

    setAnchorEl(event.currentTarget);
  }

  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  const saveArray = [];
  let obj;

  async function residentlisting(residentType) {
    let isTenent = false;
    if (residentType == "Tenent") isTenent = true;
    else isTenent = false;

    let bodyFormData = {
      searchq: q,
      pageNo: currentPage,
      count: itemsPerPage,
      isTenent: isTenent,
      sortBy: sortBy,
    };
    setShowLoader(true);
    await makePostRequest("resident/residentlisting", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          // console.log(response.data.data.rows);
          setlength(response.data.data.rowCount);
          const data = response.data.data.data;
          setresidentlist(data);

          setTotalItems(response.data.data.total_records);
          console.log(response.data.data.data.length)
          //  added new change by me for excel
          saveArray.length = 0; // Clear the array to avoid duplicate entries
          for (let i = 0; i < data.length; i++) {
            let obj = {};
            obj["resident_id"] = data[i].resident_id;
            obj["first_name"] = data[i].user_obj.first_name;
            obj["last_name"] = data[i].user_obj.last_name;
            obj["contact_no"] = data[i].user_obj.contact_no;
            obj["email_id"] = data[i].user_obj.email_id;


            // if (data[i].apartment && data[i].apartment.length > 0) {
            //   obj["apartments"] = `"${data[i].apartment
            //     .map((apt) => apt.uniq_apt_name)
            //     .join(", ")}"`; 
            // } else {
            //   obj["apartments"] = "";
            // }

            obj["apartments"] = data[i].apartment && data[i].apartment.length > 0
              ? `"${data[i].apartment.map((apt) => {
                let occupancyType = apt.occupancy_type;
                let currentStay = apt.is_current_stay ? "Yes" : "No";
                return `${apt.uniq_apt_name}-${occupancyType} (current_stay-${currentStay})`;
              }).join(", ")}"`
              : '""';

            saveArray.push(obj);
          }
          setforcsv(saveArray);
          console.log("first", saveArray)
          // console.log("obj",obj)

        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        let errMsg = err.response.data.message;
        swal(errMsg, "", "warning");
        setShowLoader(false);
      });
  }

  async function deleterecident(id) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete these records? This process cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      var bodyFormData = new FormData();
      await makeGetRequest("resident/delete/" + id, bodyFormData)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            residentlisting("Owner");
          } else {
            swal("Error", "Failed to delete", "error");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
          console.log("Invalid username password!!", err);
        });
    }
  }

  const [residentAptNamesList, setResidentAptNamesList] = React.useState([]);

  async function GetResidentAptNameList(residentId) {
    let bodyFormData = "";

    await makeGetRequest(
      "/apartment/getaptnameofresident/" + residentId,
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data);
          // setTenentFamMemlength(response.data.data.length)
          setResidentAptNamesList(response.data.data);
        } else {
          // setloading(false)
          swal("There was an error!", response.messageupload, "warning");
        }
      })
      .catch((err) => {
        // setloading(false)
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function editResident(residentId) {
    navigate("/EditResident/" + residentId);
  }

  const [tempCurrentStay, setTempCurrentStay] = React.useState(false);

  async function handleCurrentStay(tempVar) {
    // alert("Hi")
    setTempCurrentStay(tempVar);
  }


  const handleChangeTabs = (flag) => {
    setCurrentPage(1);
    setStatus(flag);
    setQ("")
  };
  const [isTokenFound, setTokenFound] = React.useState(false);
  async function testTokenFunctionality() {
    // var token = await fetchToken(setTokenFound);
    // console.log(token)
    // alert(token)
    // let inputRes={
    //   "resident_id":localStorage.getItem('userId'),
    //   "fcm_token":token
    // } ;
    // await makePostRequest("resident/update",inputRes )
    // .then((response) => {
    //     if(response.status=201)
    //     {
    //       // alert("resident updated")
    //     }
    //  }).catch((err) => {
    //   console.log(err);
    //   // swal("There was an error!", "more error details", "warning");
    // });

    setOpen(true);
    setScroll("body");

  }
  useEffect(() => {


    residentlisting(status);

    //   const scanner = new Html5QrcodeScanner('reader', {
    //     qrbox:{
    //     height:250,
    //     width:250,
    //   },
    //   fps:5,
    // })



    // function success(result)
    // {
    //   scanner.clear();
    //   setScanResult(result);
    // }

    // function error(err)
    // {
    //   console.log(err)
    // }

    // scanner.render(success, error);
  }, [q, Upload, currentPage, status]);

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);

  return (
    <>
      <Top />
      <Left />

      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Resident Management</h1>
            {/* <Button
              className="contentTopLefBt"
              onClick={() => testTokenFunctionality()}
            >
              Test
            </Button> */}
            {/* <div className="App">
      <h1>QR code Scanning in React JS</h1>
      {
        scanResult ? <div>Success: {scanResult}</div>
        :<div id='reader'></div>
      }
      
    </div> */}
            <Button
              className="contentTopLefBt"
              onClick={() => navigate("/AddResident")}
            >
              Add Resident
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead">Resident List</div>
 {/* Instruction notes in red */}
  <div
    style={{
      color: "red",
      textAlign: "left",
    }}
  >
    <strong>Import Resident Guidelines:</strong>
    <ol style={{ margin: "8px 0 0", paddingLeft: 20 }}>
      <li>First, download the provided sample CSV/Excel template.</li>
      <li>Do not rename, remove, or rearrange any of the column headers.</li>
      <li>Remove all sample rows before adding your own Resident data.</li>
      <li>Ensure each row has valid values for all required columns </li>
      
    </ol>
  </div>
                <div className="importOter">
                  
                  <ExcelToTable onImportComplete={residentlisting} importError={setImportError} />
                  <CsvDownloader
                    className="sendemailBtn"
                    filename="resident-report"
                    extension=".csv"
                    datas={csvdataarray}
                    text="Export To Excel"
                    columns={[
                      { id: "resident_id", displayName: "Resident ID" },
                      { id: "first_name", displayName: "First Name" },
                      { id: "last_name", displayName: "Last Name" },
                      { id: "contact_no", displayName: "Contact No" },
                      { id: "email_id", displayName: "Email ID" },
                      { id: "apartments", displayName: "Apartments" }
                    ]}
                  />
                </div>
                {importError && (
                  <div
                    style={{
                      background: "#ffe6e6",
                      border: "1px solid #cc0000",
                      padding: 12,
                      borderRadius: 4,
                      marginBottom: 16,
                      color: "#990000",
                      float: 'left',
                      width: '100%',
                      marginTop: 15,
                    }}
                  >
                    <strong>Error:</strong> {importError}
                  </div>
                )}

                <div className="visitorListNewInner fullWidthListing">
                  <div className="invoicePaidUnpaidTabMain">
                    <Box sx={{ width: "100%" }}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                          value={value}
                          onChange={handleChange}
                          aria-label="basic tabs example"
                          variant="scrollable"
                          scrollButtons
                          allowScrollButtonsMobile
                        >
                          <Tab
                            label="Owner list"
                            {...a11yProps(0)}
                            // onClick={() => residentlisting("Owner")}
                            onClick={() => handleChangeTabs("Owner")}
                          />

                          <Tab
                            label="Tenant list"
                            {...a11yProps(1)}
                            // onClick={() => residentlisting("Tenent")}
                            onClick={() => handleChangeTabs("Tenent")}
                          />
                        </Tabs>
                      </Box>
                      <TabPanel value={value} index={0}>
                        <div className="visitorSearch">
                          <div className="visitorSearchDiv">
                            <SearchIcon className="visitorSearchIco" />
                            <input
                              type="text"
                              placeholder="Search"
                              onChangeCapture={(e) => setQ(e.target.value)}
                            />
                            {/* <MicIcon className="visitorMicIco" />  */}
                          </div>

                          {/* <div>
                            <SortIcon
                              className="visitorFilterIco"
                              aria-controls={open10}
                              aria-haspopup="true"
                              aria-expanded={open10}
                              onClick={handleClick10}
                            />
                            <Menu
                              anchorEl={anchorEl10}
                              open={open10}
                              onClose={handleClose10}
                              MenuListProps={{
                                "aria-labelledby": "basic-button",
                              }}
                            >
                              <MenuItem onClick={handleClose10}>
                                Filter Item 1
                              </MenuItem>
                              <MenuItem onClick={handleClose10}>
                                Filter Item 2
                              </MenuItem>
                              <MenuItem onClick={handleClose10}>
                                Filter Item 3
                              </MenuItem>
                            </Menu>
                          </div> */}
                          <div className="sortingIcoOut">
                            <ToggleButton
                              value="check"
                              selected={selected}
                              onChange={() => {
                                setSelected(!selected);
                              }}
                            >
                              <ImportExportIcon
                                className="visitorFilterIco"
                                aria-controls={open ? "basic-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                onClick={(e) => handleChangeSortBy(e, 'Owner')}
                              />
                            </ToggleButton>
                          </div>
                          {/*
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        <MenuItem onClick={()=>handleChangeFilter('Owner')}>Owner</MenuItem>
                        <MenuItem onClick={()=>handleChangeFilter('Tenent')}>Tenent</MenuItem>
                      </Menu> */}
                        </div>
                        {localStorage.getItem("buildingCnt") > 0 ? (
                          <>
                            {residentlist.map((option) => (
                              <div className="visitContDiv">
                                <div className="visitCont1 resideNewContOut buildingNameNcountMain forAlignTx">
                                  {option.apartment ? (
                                    <>
                                      {/* {option.apartment.} */}
                                      {option.apartment.map((resApt, index) => (
                                        <>
                                          {resApt.is_current_stay == true ? (
                                            // {setTempCurrentStay(true)}
                                            <div className="NewTailCountOut">
                                              <div className="buildingNameNcount">
                                                <p>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[0]
                                                  }
                                                </p>
                                                <p>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[1]
                                                  }
                                                </p>
                                              </div>
                                              <h1>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[2]
                                                }
                                              </h1>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </>
                                      ))}
                                      {option.currentstaycnt.count == 0 ? (
                                        <div className="NewTailCountOut defaultTailCount">
                                          <div className="buildingNameNcount">
                                            <p>No Apart.</p>
                                            <p>Occupied</p>
                                          </div>
                                          <h1>F-000</h1>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <div className="NewTailCountOut defaultTailCount">
                                        <div className="buildingNameNcount">
                                          <p>No Apart.</p>
                                          <p>Occupied</p>
                                        </div>
                                        <h1>F-000</h1>
                                      </div>
                                    </>
                                  )}
                                  <div
                                    className="visitContProf linkCOnt"
                                    onClick={() =>
                                      navigate(
                                        "/ResidentManInfoView/" +
                                        option.resident_id
                                      )
                                    }
                                  >
                                    {option.user_obj.profile_pic ? (
                                      <img src={option.user_obj.profile_pic} />
                                    ) : (
                                      <img src={defaultProfilePic} />
                                    )}
                                  </div>
                                  <div
                                    className="visitContLeft linkCOnt"
                                    onClick={() =>
                                      navigate(
                                        "/ResidentManInfoView/" +
                                        option.resident_id
                                      )
                                    }
                                  >
                                    <h3 className="visitContHed">
                                      {option.user_obj.first_name}{" "}
                                      {option.user_obj.last_name}{" "}
                                    </h3>
                                    <p className="visitContMob">
                                      <CallIcon className="forEmailAndPhone" />
                                      {option.user_obj.contact_no}
                                    </p>
                                    <p className="visitContTime forImailAlig">
                                      <MarkunreadIcon className="forEmailAndPhone" />
                                      {option.user_obj.email_id}
                                    </p>
                                  </div>
                                  {/* <div className="visitBottCont">
                                <label className="residLab residLabGreen">
                                  Owner Occupied <b>(10)</b>
                                </label>
                                <div className="forTypeSt">
                                  <b className="forTypeStInr">
                                    <b>Building 2/Wing A/F-101</b>
                                    <em>Owner</em>
                                  </b>
                                </div>
                              </div>
                              <div className="visitBottCont">
                                <label className="residLab residLabBlue">
                                  Tenant Occupied <b>(05)</b>
                                </label>
                                <div className="forTypeSt">
                                  <b className="forTypeStInr">
                                    <b>Building 2/Wing A/F-101</b>
                                    <em>Owner</em>
                                  </b>
                                </div>
                              </div>
                              <div className="visitBottCont">
                                <label className="residLab residLabPink">
                                  Vacant Occupied <b>(20)</b>
                                </label>
                                <div className="forTypeSt">
                                  <b className="forTypeStInr">
                                    <b>Building 2/Wing A/F-101</b>
                                    <em>Owner</em>
                                  </b>
                                </div>
                              </div> */}
                                  <div className="visitBottCont visitBottContForAilgn buildingCountAlign">
                                    {option.apartment ? (
                                      <div className="forTypeSt">
                                        <p className="labSpace">
                                          Building/Wing/Flat Number
                                        </p>
                                        {option.apartment.map((option1) => (
                                          <b className="forTypeStInr">
                                            <b
                                              onClick={() =>
                                                navigate("/ApartmentHistory")
                                              }
                                            >
                                              {option1.uniq_apt_name}
                                            </b>
                                            <em>{option1.occupancy_type}</em>
                                          </b>
                                        ))}
                                      </div>
                                    ) : (
                                      <div>No Apartment Allocated </div>
                                    )}
                                  </div>

                                  {/* <div className="visitBottCont">
                                <p>User Type</p>
                                <b>{option.user_type}</b>
                              </div> */}
                                  {/* <div className="visitBottCont">
                                <p>Designation</p>
                                <b>Secretory</b>
                              </div> */}
                                  <div className="resideNewCont">
                                    {/* {localStorage.setItem(
                                  "residentid",
                                  option.resident_id
                                )} */}
                                    <CreateIcon
                                      className="editBt"
                                      onClick={() =>
                                        editResident(option.resident_id)
                                      }
                                    />
                                    <SearchIcon
                                      className="deleteBt"
                                      onClick={() =>
                                        navigate(
                                          "/ResidentManInfoView/" +
                                          option.resident_id
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                            <Grid container spacing={3} >
                              <Grid item xs={12} md={12} >
                                <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                                  page={currentPage}
                                  onChange={handlePageChange}
                                  variant="outlined"
                                  shape="rounded" />
                              </Grid>
                            </Grid>
                            {/* <div className="listPaginationMain">
                              <Stack spacing={2}>
                                <Pagination
                                  count={10}
                                  variant="outlined"
                                  shape="rounded"
                                />
                              </Stack>
                            </div> */}
                          </>
                        ) : (
                          <>
                            {residentlist.map((option) => (
                              <div className="visitContDiv">
                                <div className="visitCont1 resideNewContOut buildingNameNcountMain forAlignTx">
                                  <div className="NewTailCountOut">
                                    <img src={bungalow} />
                                    {option.apartment ? (
                                      <>
                                        {option.apartment.map(
                                          (resApt, index) => (
                                            <>
                                              {resApt.is_current_stay ==
                                                true ? (
                                                <p className="bnglowLabl">
                                                  {resApt.uniq_apt_name}
                                                </p>
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          )
                                        )}
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>

                                  <div
                                    className="visitContProf linkCOnt"
                                    onClick={() =>
                                      navigate(
                                        "/ResidentManInfoView/" +
                                        option.resident_id
                                      )
                                    }
                                  >
                                    {option.user_obj.profile_pic ? (
                                      <img src={option.user_obj.profile_pic} />
                                    ) : (
                                      <img src={defaultProfilePic} />
                                    )}
                                  </div>
                                  <div
                                    className="visitContLeft linkCOnt"
                                    onClick={() =>
                                      navigate(
                                        "/ResidentManInfoView/" +
                                        option.resident_id
                                      )
                                    }
                                  >
                                    <h3 className="visitContHed">
                                      {option.user_obj.first_name}{" "}
                                      {option.user_obj.last_name}{" "}
                                    </h3>
                                    <p className="visitContMob">
                                      <CallIcon className="forEmailAndPhone" />
                                      {option.user_obj.contact_no}
                                    </p>
                                    <p className="visitContTime forImailAlig">
                                      <MarkunreadIcon className="forEmailAndPhone" />
                                      {option.user_obj.email_id}
                                    </p>
                                  </div>
                                  {/* <div className="visitBottCont">
                                <label className="residLab residLabGreen">
                                  Owner Occupied <b>(10)</b>
                                </label>
                                <div className="forTypeSt">
                                  <b className="forTypeStInr">
                                    <b>Building 2/Wing A/F-101</b>
                                    <em>Owner</em>
                                  </b>
                                </div>
                              </div>
                              <div className="visitBottCont">
                                <label className="residLab residLabBlue">
                                  Tenant Occupied <b>(05)</b>
                                </label>
                                <div className="forTypeSt">
                                  <b className="forTypeStInr">
                                    <b>Building 2/Wing A/F-101</b>
                                    <em>Owner</em>
                                  </b>
                                </div>
                              </div>
                              <div className="visitBottCont">
                                <label className="residLab residLabPink">
                                  Vacant Occupied <b>(20)</b>
                                </label>
                                <div className="forTypeSt">
                                  <b className="forTypeStInr">
                                    <b>Building 2/Wing A/F-101</b>
                                    <em>Owner</em>
                                  </b>
                                </div>
                              </div> */}
                                  <div className="visitBottCont visitBottContForAilgn buildingCountAlign">
                                    {option.apartment ? (
                                      <div className="forTypeSt">
                                        {/* <p>Owner Name</p>
                                    <b>Sadashiv Shirsath</b> */}
                                        {option.apartment.map((option1) => (
                                          <b className="forTypeStInr">
                                            <b>{option1.uniq_apt_name}</b>
                                            <em>{option1.occupancy_type}</em>
                                          </b>
                                        ))}
                                      </div>
                                    ) : (
                                      <div>No Bunglow Allocated </div>
                                    )}
                                  </div>

                                  {/* <div className="visitBottCont">
                                <p>User Type</p>
                                <b>{option.user_type}</b>
                              </div> */}
                                  {/* <div className="visitBottCont">
                                <p>Designation</p>
                                <b>Secretory</b>
                              </div> */}
                                  <div className="resideNewCont">
                                    {/* {localStorage.setItem(
                                  "residentid",
                                  option.resident_id
                                )} */}
                                    <CreateIcon
                                      className="editBt"
                                      onClick={() =>
                                        editResident(option.resident_id)
                                      }
                                    />
                                    <SearchIcon
                                      className="deleteBt"
                                      onClick={() =>
                                        navigate(
                                          "/ResidentManInfoView/" +
                                          option.resident_id
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}

                            <Grid container spacing={3} >
                              <Grid item xs={12} md={12} >
                                <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                                  page={currentPage}
                                  onChange={handlePageChange}
                                  variant="outlined"
                                  shape="rounded" />
                              </Grid>
                            </Grid>
                          </>
                        )}
                      </TabPanel>

                      <TabPanel
                        value={value}
                        index={1}
                        className="tenantSmallTab"
                        style={{ minWidth: 800, }}
                      >
                        <div className="visitorSearch">
                          <div className="visitorSearchDiv">
                            <SearchIcon className="visitorSearchIco" />
                            <input
                              type="text"
                              placeholder="Search"
                              onChangeCapture={(e) => setQ(e.target.value)}
                            />
                            {/* <MicIcon className="visitorMicIco" /> */}
                          </div>
                          {/* <div>
                            <SortIcon
                              className="visitorFilterIco"
                              aria-controls={open10 ? "basic-menu" : undefined}
                              aria-haspopup="true"
                              aria-expanded={open10 ? "true" : undefined}
                              onClick={handleClick10}
                            />
                            <Menu
                              id="basic-menu"
                              anchorEl={anchorEl10}
                              open={open10}
                              onClose={handleClose10}
                              MenuListProps={{
                                "aria-labelledby": "basic-button",
                              }}
                            >
                              <MenuItem onClick={handleClose10}>
                                Filter Item 1
                              </MenuItem>
                              <MenuItem onClick={handleClose10}>
                                Filter Item 2
                              </MenuItem>
                              <MenuItem onClick={handleClose10}>
                                Filter Item 3
                              </MenuItem>
                            </Menu>
                          </div> */}

                          <div className="sortingIcoOut">
                            <ToggleButton
                              value="check"
                              selected={selected}
                              onChange={() => {
                                setSelected(!selected);
                              }}
                            >
                              <ImportExportIcon
                                className="visitorFilterIco"
                                aria-controls={open ? "basic-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                onClick={(e) => handleChangeSortBy(e, 'Tenent')}
                              />
                            </ToggleButton>
                          </div>
                        </div>
                        {localStorage.getItem("buildingCnt") > 0 ? (
                          <>
                            {residentlist.map((option) => (
                              <div className="visitContDiv">
                                <div className="visitCont1 resideNewContOut buildingNameNcountMain">
                                  {option.uniq_apt_name && option.uniq_apt_name[0] ? (
                                    <div className="NewTailCountOut forTenantColor">
                                      <div className="buildingNameNcount">
                                        <p>
                                          {" "}
                                          {
                                            option.uniq_apt_name[0].split(
                                              "/"
                                            )[0]
                                          }
                                        </p>
                                        <p>
                                          {
                                            option.uniq_apt_name[0].split(
                                              "/"
                                            )[1]
                                          }
                                        </p>
                                      </div>
                                      <h1>
                                        {option.uniq_apt_name[0].split("/")[2]}
                                      </h1>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  <div
                                    className="visitContProf linkCOnt"
                                    onClick={() =>
                                      navigate(
                                        "/TenentManagInfoView/" +
                                        option.resident_id
                                      )
                                    }
                                  >
                                    {option.user_obj.profile_pic ? (
                                      <img src={option.user_obj.profile_pic} />
                                    ) : (
                                      <img src={defaultProfilePic} />
                                    )}
                                  </div>
                                  <div
                                    className="visitContLeft linkCOnt"
                                    onClick={() =>
                                      navigate(
                                        "/TenentManagInfoView/" +
                                        option.resident_id
                                      )
                                    }
                                  >
                                    <h3 className="visitContHed">
                                      {option.user_obj.first_name}{" "}
                                      {option.user_obj.last_name}
                                    </h3>
                                    <p className="visitContMob">
                                      <CallIcon className="forEmailAndPhone" />
                                      {option.user_obj.contact_no}
                                    </p>
                                    <p className="visitContTime forImailAlig">
                                      <MarkunreadIcon className="forEmailAndPhone" />
                                      {option.user_obj.email_id}
                                    </p>
                                  </div>
                                  <div className="visitBottCont visitBottContForAilgn">
                                    <p>Building/Wing/Flat Number</p>
                                    {option.apartment ? (
                                      <div>
                                        {option.apartment.map((option1) => (
                                          <b>{option1.uniq_apt_name} </b>
                                        ))}
                                      </div>
                                    ) : (
                                      <div></div>
                                    )}
                                  </div>
                                  {option.ownername ? (
                                    <div className="visitBottCont">
                                      <p>Owner Name</p>
                                      <b>
                                        {option.ownername.firstname}{" "}
                                        {option.ownername.lastname}
                                      </b>
                                      {/* <b>{option.resident[0].name}</b> */}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  <div className="resideNewCont">
                                    {/* {localStorage.setItem(
                                  "residentid",
                                  option.resident_id
                                )} */}
                                    {/* {localStorage.setItem(
                                  "residentid",
                                  option.residenent_user_id
                                )} */}
                                    <CreateIcon
                                      className="editBt"
                                      onClick={() =>
                                        editResident(option.residenent_user_id)
                                      }
                                    />
                                    <SearchIcon
                                      className="deleteBt"
                                      onClick={() =>
                                        navigate(
                                          "/TenentManagInfoView/" +
                                          option.resident_id
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                            <Grid container spacing={3} >
                              <Grid item xs={12} md={12} >
                                <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                                  page={currentPage}
                                  onChange={handlePageChange}
                                  variant="outlined"
                                  shape="rounded" />
                              </Grid>
                            </Grid>
                            {/* <div className="listPaginationMain">
                              <Stack spacing={2}>
                                <Pagination
                                  count={10}
                                  variant="outlined"
                                  shape="rounded"
                                />
                              </Stack>
                            </div> */}
                          </>
                        ) : (
                          <>
                            {residentlist.map((option) => (
                              <div className="visitContDiv">
                                <div className="visitCont1 resideNewContOut buildingNameNcountMain forAlignTx">
                                  <div className="NewTailCountOut">
                                    <img src={bungalow} />
                                    <p className="bnglowLabl">
                                      {option.uniq_apt_name[0]}
                                    </p>
                                  </div>
                                  <div
                                    className="visitContProf linkCOnt"
                                    onClick={() =>
                                      navigate(
                                        "/TenentManagInfoView/" +
                                        option.resident_id
                                      )
                                    }
                                  >
                                    {option.user_obj.profile_pic ? (
                                      <img src={option.user_obj.profile_pic} />
                                    ) : (
                                      <img src={defaultProfilePic} />
                                    )}
                                  </div>
                                  <div
                                    className="visitContLeft linkCOnt"
                                    onClick={() =>
                                      navigate(
                                        "/TenentManagInfoView/" +
                                        option.resident_id
                                      )
                                    }
                                  >
                                    <h3 className="visitContHed">
                                      {option.user_obj.first_name}{" "}
                                      {option.user_obj.last_name}
                                    </h3>
                                    <p className="visitContMob">
                                      <CallIcon className="forEmailAndPhone" />
                                      {option.user_obj.contact_no}
                                    </p>
                                    <p className="visitContTime forImailAlig">
                                      <MarkunreadIcon className="forEmailAndPhone" />
                                      {option.user_obj.email_id}
                                    </p>
                                  </div>
                                  <div className="visitBottCont visitBottContForAilgn">
                                    <p>Building/Wing/Flat Number</p>
                                    {option.apartment ? (
                                      <div>
                                        {option.apartment.map((option1) => (
                                          <b>{option1.uniq_apt_name} </b>
                                        ))}
                                      </div>
                                    ) : (
                                      <div></div>
                                    )}
                                  </div>
                                  {option.ownername ? (
                                    <div className="visitBottCont">
                                      <p>Owner Name</p>
                                      <b>
                                        {option.ownername.firstname}{" "}
                                        {option.ownername.lastname}
                                      </b>

                                      {/* <b>{option.resident[0].name}</b> */}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  <div className="resideNewCont">
                                    {/* {localStorage.setItem(
                                  "residentid",
                                  option.resident_id
                                )} */}
                                    {/* {localStorage.setItem(
                                  "residentid",
                                  option.residenent_user_id
                                )} */}
                                    <CreateIcon
                                      className="editBt"
                                      onClick={() =>
                                        editResident(option.residenent_user_id)
                                      }
                                    />
                                    <SearchIcon
                                      className="deleteBt"
                                      onClick={() =>
                                        navigate(
                                          "/ResidentManInfoView/" +
                                          option.resident_id
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                            <Grid container spacing={3} >
                              <Grid item xs={12} md={12} >
                                <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                                  page={currentPage}
                                  onChange={handlePageChange}
                                  variant="outlined"
                                  shape="rounded" />
                              </Grid>
                            </Grid>
                          </>
                        )}
                      </TabPanel>
                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Entry Pass Preview</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <div className="entryPassMain entryPassMain2">
                      <div className="entryPassInner">
                        <h4 className="entryParkHeading">Test</h4>
                        <div className="entryPassPro">
                          <Zoom>

                            <img src={defaultProfilePic} />

                          </Zoom>
                        </div>
                        <div>
                          {/* <Button className="serviceNameBt">Maid</Button> */}
                        </div>
                        <div className="entryPassNameNum">
                          <p>Samar Singh</p>
                          <span>96544112233</span>
                        </div>
                        <div className="entryPassBott">
                          <div className="emtyPssBarOut">
                            {/* <Zoom>
                              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/QR_Code_Example.svg/1024px-QR_Code_Example.svg.png" />
                            </Zoom> */}
                            <Zoom>
                              <div style={{ height: "auto", margin: "0 auto", maxWidth: 64, width: "100%" }}>
                                <QRCode
                                  size={256}
                                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                  value={JSON.stringify({ id: 1, contact: 9656326598, guard_name: 'Snehal' })}
                                  viewBox={`0 0 256 256`}
                                />
                              </div></Zoom>
                            <button onClick={(e) => { console.log(e) }}>Scan Qr Code</button>
                          </div>
                          <p>Powered by Resipro</p>
                        </div>

                        <div>
                          <QRReader
                            delay={300}
                            onError={handleError}
                            onScan={handleScan}
                            style={{ width: '50%' }}
                          />

                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      {/* <Button className="modalMainBt" onClick={addCommitee}>
                        Download
                      </Button> */}
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>Successfully Downloaded</p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default ResidentManagement2;
